import { ContentStat } from "seneca-common/features/stats/state";
import { chooseMFromN } from "seneca-common/utils/functions";
import shuffle from "seneca-common/utils/functions/random/shuffle";

import lastAttemptIncorrect from "../../../utils/logic/lastAttemptIncorrect";
import { GenerateContentOptions } from "../../types";
import { Content, ContentSource } from "../types";

export function generateContent(
  source: ContentSource,
  { testingActive, maxDifficulty }: GenerateContentOptions,
  contentStat?: ContentStat
): Content {
  if (!testingActive) return source;

  const toTest = getMaxTested(
    contentStat,
    maxDifficulty,
    source.definitions.length
  );

  const testedIndexes = chooseMFromN(toTest, source.definitions.length);

  const contentDefinitions = source.definitions.map((definition, index) => {
    return { ...definition, testing: testedIndexes.includes(index) };
  });

  return {
    title: source.title,
    definitions: shuffle(contentDefinitions)
  };
}

const MAX_TO_TEST = 4;

function getMaxTested(
  meta: ContentStat | null | undefined,
  maxDifficulty?: boolean,
  // @ts-ignore
  testableDefinitions: number
): number {
  const deduction = !maxDifficulty && lastAttemptIncorrect(meta) ? 1 : 0;

  let maxTested;

  if (maxDifficulty) {
    maxTested = MAX_TO_TEST;
  } else if (!meta || meta.timesStudied < 2) {
    maxTested = 1;
  } else if (meta.timesStudied < 4) {
    maxTested = 2;
  } else if (meta.timesStudied < 6) {
    maxTested = 3;
  } else {
    maxTested = MAX_TO_TEST;
  }

  maxTested = Math.min(maxTested, testableDefinitions);

  return Math.max(1, maxTested - deduction);
}
